import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { Image } from '@openedx/paragon';
import PropTypes from 'prop-types';

export const getOrgLogoUrl = ({ dark = false } = {}) => {
  const orgName = new URLSearchParams(window.location.search).get('orgName');
  const basePath = getConfig().MINIO_BASE_URL
    ? `${getConfig().MINIO_BASE_URL}/${getConfig().MINIO_BUCKET_NAME}/${getConfig().ORGANISATION_LOGO_PATH}`
    : `${getConfig().LMS_BASE_URL}/media/organisation-logos/`;
  const fileName = dark ? 'dark-logo.png' : 'logo.png';
  const logoPath = orgName ? `${orgName}/${fileName}` : fileName;
  return basePath + logoPath;
};

const AuthCard = ({
  title, subtitle, footer, children,
}) => (
  <section className="auth-card">
    <header className="auth-card__header">
      <Image
        className="auth-card__logo"
        alt="logo"
        src={getOrgLogoUrl()}
      />
      <h1 className="auth-card__title">{title}</h1>
      {subtitle && <p className="auth-card__subtitle">{subtitle}</p>}
    </header>
    {children}
    {footer && <div className="auth-card__footer">{footer}</div>}
  </section>
);

AuthCard.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node.isRequired,
};

AuthCard.defaultProps = {
  subtitle: null,
  footer: null,
};

export default AuthCard;
